export { ProductSuggestionItem } from './ProductSuggestionItem';
